import { ReactComponent as Icon } from "../files/pulse.svg";

import ISVGIconProps from "../ISVGIconProps";

const PulseIcon = ({
    fill,  
    style = {},
}: ISVGIconProps) => {   
    return (
        <div style={style}>
            <Icon
                fill={fill} 
                style={style}        
            />
        </div>
    );
};

export default PulseIcon;
